/**
 * FileDragDrop
 */
class FileDragDrop
{
    /**
	 * FileDragDrop constructor
	 * @param selector {string}
	 * @param options {Object}
	 */
    constructor(selector, options = {})
    {
        // selectors
        this.selector = selector;
        this.dropZoneSelector = '.js-file-drag-drop__drop-zone';
        this.fileListSelector = '.js-file-drag-drop__file-list';
        this.buttonSelector = '.js-file-drag-drop__button';
        this.inputSelector = 'input';

        // elements
        this.fileDragDrop = document.querySelector(this.selector);
        this.dropZone = null;
        this.fileList = null;
        this.input = null;
        this.button = null;

        // options
        this.options = Object.assign({
            dragOverClass: 'file-upload__drop-zone--drag-over'
        }, options);

        // initials
        this.initials = {
        };
    }

    /**
	 * Init wizard
	 */
    init()
    {
        if (this.fileDragDrop !== null)
        {
            this.dropZone = this.fetchDropZone();
            this.fileList = this.fetchFileList();
            this.button = this.fetchButton();
            this.input = this.fetchInput();

            this.initEvents();
        }
    }

    /**
	 *
	 */
    initEvents()
    {
        this.dropZone.addEventListener('drop', this.onDropHandler.bind(this));
        this.dropZone.addEventListener('dragover', this.onDragOverHandler.bind(this));
        this.dropZone.addEventListener('dragleave', this.onDragLeaveHandler.bind(this));
        this.input.addEventListener('change', this.onChangeHandler.bind(this));
        this.button.addEventListener('click', this.onClickHandler.bind(this));
    }

    fetchFileList()
    {
        return this.fileDragDrop.querySelector(this.fileListSelector);
    }

    fetchDropZone()
    {
        return this.fileDragDrop.querySelector(this.dropZoneSelector);
    }

    fetchButton()
    {
        return this.fileDragDrop.querySelector(this.buttonSelector);
    }

    fetchInput()
    {
        return this.fileDragDrop.querySelector(this.inputSelector);
    }

    clearFileList()
    {
        while (this.fileList.firstChild)
        {
            this.fileList.removeChild(this.fileList.firstChild);
        }
    }

    generateFileListElement()
    {
        return document.createElement('ul');
    }

    generateFileListItemElement(filename)
    {
        let li = document.createElement('li');

        li.textContent = filename;

        return li;
    }

    updateFileList(files)
    {
        this.clearFileList();

        console.log(files);

        let fileListElement = this.generateFileListElement();

        files.forEach((file) =>
        {
            fileListElement.appendChild(this.generateFileListItemElement(file));
        });

        this.fileList.appendChild(fileListElement);
    }

    onDropHandler(event)
    {
        // prevent files from being opened in browser
        event.preventDefault();

        if (!event.dataTransfer.items.length && !event.dataTransfer.files.length)
        {
            // no files
            return;
        }

        this.clearFileList();

        this.input.files = event.dataTransfer.files;

        let files = [];

        if (event.dataTransfer.items)
        {
            // Use DataTransferItemList interface to access the file(s)
            for (let i = 0; i < event.dataTransfer.items.length; i++)
            {
                // If dropped items aren't files, reject them
                if (event.dataTransfer.items[i].kind === 'file')
                {
                    let file = event.dataTransfer.items[i].getAsFile();

                    files.push(file.name);
                }
            }
        }
        else
        {
            // Use DataTransfer interface to access the file(s)
            for (let i = 0; i < event.dataTransfer.files.length; i++)
            {
                files.push(event.dataTransfer.files[i].name);
            }
        }

        this.updateFileList(files);

        $(this.input).trigger('change');
    }

    onDragOverHandler(event)
    {
        // prevent files from being opened in browser
        event.preventDefault();

        this.dropZone.classList.add(this.options.dragOverClass);
    }

    onDragLeaveHandler()
    {
        this.dropZone.classList.remove(this.options.dragOverClass);
    }

    onChangeHandler()
    {
        let fileList = this.input.files;

        let files = [];

        Array.from(fileList).forEach((file) =>
        {
            files.push(file.name);
        });

        this.updateFileList(files);
    }

    onClickHandler(event)
    {
        event.preventDefault();

        this.input.click();
    }
}

let fileDragDrop = new FileDragDrop('.js-file-drag-drop');

fileDragDrop.init();
